<template>
    <!-- ===================== Normal view type ===================== -->
    <main id="issues-container">
        <b-container v-if="locationType == 'normal'">
            <Issues
                ref="issues-page"
                :subjectsOptions="subjectsOptions"
                :responsiblesOptions="responsiblesOptions"
                :locationsOptions="locationsOptions"
                :project="project"
            />
        </b-container>
        <ViewerIssues ref="viewer-issues-page" v-if="locationType == 'viewer'" locationType="viewer" :project="project" :currentFloorplan="currentFloorplan" />
    </main>
</template>

<script>
// =====================
// External
// =====================
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

// =====================
// UI Components
// =====================
import Issues from '@/views/Project/Issues/Issues.vue'
import ViewerIssues from '@/views/Project/Issues/ViewerIssues.vue'

// ==========================
// Icons
// ==========================
import 'vue-awesome/icons/sort-amount-down'
import 'vue-awesome/icons/sort-amount-down-alt'
import 'vue-awesome/icons/filter'
import 'vue-awesome/icons/file-download'
import 'vue-awesome/icons/file-pdf'
import 'vue-awesome/icons/file-excel'
import 'vue-awesome/icons/chevron-left'

import { mapState, mapActions } from 'vuex'
// ===========
// JSON data
// ===========
import getProjectLocations from '@/data/getProjectLocation.js'

export default {
    components: {
        Issues,
        ViewerIssues,
    },
    props: {
        locationType: {
            type: String,
            default: 'normal', // normal | viewer
        },
        currentFloorplan: Object,
        project_id: {
            type: Number,
            default: -1,
        },
        isOpen: Boolean,
    },

    data() {
        return {
            // Options
            subjectsOptions: [],
            responsiblesOptions: [],
            locationsOptions: [],

            project: {},
        }
    },

    methods: {
        setup() {
            // Fetch issue options (Types, Causes and subjects)
            // this.getIssueInfoOptions()

            this.isMobile = this.$Mobile.verify()

            if (this.isFirstRequest && this.$route.query.status && (this.$route.query.issue || this.$route.query.issue_id)) {
                this.changeTabContent(this.$route.query.status)
            } else if (this.isFirstRequest && (!this.$route.query.status || (!this.$route.query.issue && !this.$route.query.issue_id))) {
                if (this.locationType == 'viewer') {
                    let locations = this.currentFloorplan.viewpoints.map((v) => v.id)
                    this.issueOptions.filter = { locations }
                }

                this.isFirstRequest = false
                this.$nextTick((_) => {
                    if (this.$refs['issues-list-viewer']) {
                        this.$refs['issues-list-viewer'].orderByFilter = 1
                    }
                })
            }
        },
    },

    mounted() {
        // Dont execute the setup on mount if is inside viewer to prevent performance leaks on first load
        // if (this.locationType != 'viewer') {
        this.setup()
        // }
        this.project = getProjectLocations.data.getProject

        // this.$apollo.query({
        //     query: getProjectLocations,
        //     variables: {
        //         id: Number(this.$route.params.project_id) || Number(this.$route.params.id) || Number(this.$route.query.p)
        //     },
        //     fetchPolicy: 'no-cache',
        // })
        // .then(({data}) => {
        //     this.project = data.getProject
        // })
    },
}
</script>

<style lang="scss" scoped>
@import '@/scss/views/Project/Issues/issues-container.scss';
</style>
